<template>
    <div>
        <GmapMarker 
            v-for="marker in markers" :key="marker.marker_id" 
            :position="marker.position" 
            :options="marker.options" 
            @click="openInfo(marker.marker_id)">
            <GmapInfoWindow @closeclick="openInfo(null)" v-if="openedMarkerId === marker.marker_id">
                <mapInfoLead :markerData="marker" v-if="marker.marker_type==='lead'"/>
                <mapInfoHost :markerData="marker" v-if="marker.marker_type==='host'"/>
                <mapInfoHuis :markerData="marker" v-if="marker.marker_type==='huis'"/>
            </GmapInfoWindow>
        </GmapMarker>
    </div>
</template>

<script>
    import mapInfoLead from "@/components/pten/mapInfoLead.vue";
    import mapInfoHost from "@/components/pten/mapInfoHost.vue";
    import mapInfoHuis from "@/components/pten/mapInfoHuis.vue";

    export default {
        components: {
            mapInfoLead,
            mapInfoHost,
            mapInfoHuis,
        },
        props: {
            markers: {
                type: Array,
                required: true,
            },
            openedMarkerId: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
            }
        },
        methods: { 
            openInfo(id) {
                console.log("id:", id)
                this.$emit("openInfo", id);
            },
        },
    }
</script>

